/**
 * Created by anatoly on 31.01.2025
 */

const CustomerRecipeIconView = function (row) {
    const config = bundles.questsgroupicon.jsons.customerrecipeicon_prefab_json;
    const node = Prefab.instantiate(config, { row });
    node.avoidNode = "CustomerRecipeIconView";
    return node;
};